// utils/cache.ts

interface CacheEntry {
  value: any;
  timeout: NodeJS.Timeout | null;
}

const cache = new Map<string, CacheEntry>();

export function getFromCache(key: string): any {
  const entry = cache.get(key);
  return entry ? entry.value : null;
}

export function setInCache(key: string, value: any, ttl?: number): void {
  const existingEntry = cache.get(key); // Renamed 'entry' to 'existingEntry' for clarity

  if (existingEntry && existingEntry.timeout) {
    clearTimeout(existingEntry.timeout);
  }

  // 显式声明 newEntry 的类型
  const newEntry: CacheEntry = { value, timeout: null };
  // cache.set(key, newEntry); // 可以在这里设置，也可以在 timeout 赋值后设置

  if (ttl) {
    newEntry.timeout = setTimeout(() => {
      cache.delete(key);
    }, ttl);
    // 注意：setTimeout 在 Node.js 环境下返回 NodeJS.Timeout，
    // 在浏览器环境下返回一个 number。
    // 如果你的代码可能在浏览器环境运行，类型应该是 number | null。
    // 假设这里是纯 Node.js 环境，NodeJS.Timeout 是正确的。
  }
  
  cache.set(key, newEntry); // 将最终的 newEntry（可能已包含 timeout）存入缓存
}

